module.exports = __webpack_public_path__ + "static/media/General Post Office c. 1964.28650466.jpg";